export default function ComplianceBar() {
  return (
    <div
      data-testid="compliance-bar"
      className="w-full bg-black/80 border-b border-white/[0.04] text-zinc-500 text-[11px] tracking-wide"
    >
      <div className="container-x py-2 flex items-center justify-center text-center">
        <span>
          General information only, not financial product advice. No brokerage or AFSL-regulated services.
        </span>
      </div>
    </div>
  );
}
